import { render } from "./ProcessIllustration.vue?vue&type=template&id=13740b12"
import script from "./ProcessIllustration.vue?vue&type=script&lang=js"
export * from "./ProcessIllustration.vue?vue&type=script&lang=js"

import "./ProcessIllustration.vue?vue&type=style&index=0&id=13740b12&lang=css"
script.render = render

export default script